import { DailyChallenge } from "../core";
import { playGamesMock } from "../mock";

function computeDateKey(date: Date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function getDailyChallenge(date: Date = new Date()): DailyChallenge | null {
  if (!playGamesMock.length) return null;
  const dateKey = computeDateKey(date);
  const seed = date.getFullYear() + date.getMonth() + date.getDate();
  const index = seed % playGamesMock.length;
  const game = playGamesMock[index];

  return {
    dateKey,
    gameId: game.id,
    title: `Défi du jour : ${game.title}`,
    shortDescription: game.description,
  };
}
